<template>
  <div class="ranking-bar-chart">
    <BaseChartTooltip
      v-for="(item, index) in sortedItems"
      :key="index"
      :label="item.value"
      class="ranking-bar-chart__item"
      :data-field="dataFieldFor(index)"
    >
      <template v-if="item.entity">
        <BaseEntityBadge
          class="ranking-bar-chart__badge"
          :initials="item.entity.initials"
          :name="item.entity.name"
          :meta="item.entity.meta"
        />
      </template>
      <span
        v-else
        class="ranking-bar-chart__label"
      >{{ item.label }}</span>
      <span class="ranking-bar-chart__track">
        <span
          class="ranking-bar-chart__fill"
          :style="{ width: `${item.widthPct}%` }"
        />
      </span>
      <span class="ranking-bar-chart__value">{{ item.value }}</span>
    </BaseChartTooltip>
  </div>
</template>

<script>
import BaseChartTooltip from './BaseChartTooltip.vue'
import BaseEntityBadge from './BaseEntityBadge.vue'
import DataFieldByIndex from './DataFieldByIndex'

const ZERO_VALUE_WARNING_RATIO = 0.8

export default {
  name: 'BaseRankingBarChart',
  components: { BaseChartTooltip, BaseEntityBadge },
  mixins: [DataFieldByIndex],
  props: {
    items: {
      type: Array,
      required: true
    }
  },
  computed: {
    sortedItems() {
      const sorted = [...this.items].sort((a, b) => (b.rawValue || 0) - (a.rawValue || 0))
      const max = sorted.length ? (sorted[0].rawValue || 0) : 0
      return sorted.map((item) => ({
        ...item,
        widthPct: max > 0 ? ((item.rawValue || 0) / max) * 100 : 0
      }))
    }
  },
  created() {
    if (process.env.NODE_ENV !== 'production' && this.items.length) {
      const zeroCount = this.items.filter((item) => !item.rawValue).length
      if (zeroCount / this.items.length > ZERO_VALUE_WARNING_RATIO) {
        // eslint-disable-next-line no-console
        console.warn(
          'BaseRankingBarChart: mais de 80% dos itens têm valor zero. ' +
          'Ranking não é adequado para uma exceção pontual num grupo majoritariamente zero — considere Reconciliation Panel ou Rules Panel.'
        )
      }
    }
  }
}
</script>

<style lang="scss">
.ranking-bar-chart {
  &__item {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 11px;
    width: 100%;

    &:last-child {
      margin-bottom: 0;
    }
  }

  &__label {
    width: 84px;
    flex: none;
    font-size: 12px;
    color: var(--ds-color-black-055);
    font-weight: 500;
    text-align: right;
  }

  &__badge {
    width: 160px;
    flex: none;
  }

  &__track {
    flex: 1;
    height: 14px;
    background: var(--ds-color-black-005);
    border-radius: 3px;
    overflow: hidden;
    display: block;
  }

  &__fill {
    height: 100%;
    background: var(--v-primary-base);
    border-radius: 3px;
    display: block;
    transition: width 0.2s ease;
  }

  &__value {
    width: 66px;
    flex: none;
    text-align: right;
    font-size: 12px;
    font-weight: 700;
    font-variant-numeric: tabular-nums;
    color: var(--v-textPrimary-base);
  }
}
</style>
